/** Time to wait after useIsFetching() hits 0 before declaring settlement */
export const VIEW_HEALTH_DEBOUNCE_MS = 150;

/** Max time to wait for page load before sending timeout beacon */
export const VIEW_HEALTH_TIMEOUT_MS = 15_000;

/** Backend endpoint for view health beacons */
export const VIEW_HEALTH_ENDPOINT = '/api/metrics/frontend/';

/** HTTP timeout for beacon POST requests (fire-and-forget, keep short) */
export const VIEW_HEALTH_BEACON_TIMEOUT_MS = 5_000;
